import { render, staticRenderFns } from "./ModifyPhone.vue?vue&type=template&id=635a1e2c&scoped=true&"
import script from "./ModifyPhone.vue?vue&type=script&lang=ts&"
export * from "./ModifyPhone.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyPhone.vue?vue&type=style&index=0&id=635a1e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a1e2c",
  null
  
)

export default component.exports